import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetErpOrdersByOrderInput } from './GetErpOrdersByOrderInput';
import { GetErpOrdersByOrderOutput } from './GetErpOrdersByOrderOutput';

export class GetErpOrdersByOrderService extends HttpServiceBase {

  handle = (input: GetErpOrdersByOrderInput): Promise<Result<GetErpOrdersByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetErpOrdersByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-orders`);
    return promise;
  }
}